import { createSlice } from '@reduxjs/toolkit';
import { getDeviceId } from '../../utils/deviceHelper';

const initialState = {
  items: [], // We will primarily use RTK Query state, but keep this for potential local syncing
  token: getDeviceId(),
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCartItems: (state, action) => {
      state.items = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
      localStorage.setItem('cartToken', action.payload);
    },
    // We keep these for now but they will mostly be handled by API mutations
    addToCart: (state, action) => {
      // Local addition logic if needed for optimistic UI
    },
    removeFromCart: (state, action) => {
      // Local removal logic
    },
    updateQuantity: (state, action) => {
      // Local update logic
    },
    clearCart: (state) => {
      state.items = [];
    },
  },
});

export const { setCartItems, setToken, addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
